import { render, staticRenderFns } from "./veStuAssocFunds.vue?vue&type=template&id=70365b3a&scoped=true"
import script from "./veStuAssocFunds.vue?vue&type=script&lang=js"
export * from "./veStuAssocFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70365b3a",
  null
  
)

export default component.exports